import type { StructuredDatasetQuery } from "metabase-types/api";

export const STRUCTURED_QUERY_TEMPLATE: StructuredDatasetQuery = {
  database: null,
  type: "query",
  query: {
    "source-table": null,
  },
};
